export const normalizePhoneNumber = (countryCode: string, phoneNumber: string) => {
  const phone = phoneNumber.substring(0, 3) + ' ' + phoneNumber.substring(3, 6) + ' ' + phoneNumber.substring(6, 10);
  return `+${countryCode} ${phone}`;
};
